import { Box, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";

import AdminReadme from "../AdminReadme";

interface ToolWrapperProps {
  isLoading: boolean;
  title: string;
  readme: string[];
}

const ToolWrapper: React.FC<PropsWithChildren<ToolWrapperProps>> = ({ isLoading, readme, title, children }) => {
  return (
    <Box p={3} display="flex" height="100%">
      {isLoading ? (
        <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress size="5rem" />
        </Box>
      ) : (
        <Stack alignItems="center" spacing={2} display="flex" flex={1}>
          <Stack direction="row" display="flex" maxWidth="100%">
            <Typography flexGrow={1} variant="h5" align="center">
              {title}
            </Typography>
            <AdminReadme readme={readme} />
          </Stack>
          <Paper sx={{ width: "100%", display: "flex", flex: 1 }}>{children}</Paper>
        </Stack>
      )}
    </Box>
  );
};

export default ToolWrapper;
